import {
  USER_PENDING_REQUEST_COUNT,
  USER_PENDING_REQUEST_COUNT_SUCCESS,
  USER_PENDING_REQUEST_COUNT_ERROR,
  USER_PENDING_REQUEST_COUNT_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UserPendingRequestCount = (state = initialState, action) => {
  switch (action.type) {
    case USER_PENDING_REQUEST_COUNT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case USER_PENDING_REQUEST_COUNT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case USER_PENDING_REQUEST_COUNT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case USER_PENDING_REQUEST_COUNT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UserPendingRequestCount;
